/**
 * Constants for Knowledge Base functionality
 */

/**
 * Accepted file types for document upload in Knowledge Base
 */
export const ACCEPTED_FILE_TYPES = ['.xlsx', '.csv', '.pdf', '.docx', '.pptx', '.txt'];
